<template >
  <div v-if="navOddIdx > -1">
    <div class="num-item">
      <div class="num" :class="{ 'grey': !currentOdd.init_score }">{{ currentOdd.init_score || '-' }}</div>
      <div class="num grey" v-if="currentOdd.type === 102">{{ currentOdd.init_handicap || '' }}</div>
      <div class="num" :class="{ 'grey': !currentOdd.init_small_score }">{{ currentOdd.init_small_score || '-' }}</div>
    </div>
    <div class="num-item">
      <div class="num" :class="[!currentOdd.now_score ? 'grey' : '', homeClass]">{{ currentOdd.now_score || '-' }}</div>
      <div class="num grey" v-if="currentOdd.type === 102">{{ currentOdd.now_handicap || '' }}</div>
      <div class="num" :class="[!currentOdd.now_small_score ? 'grey' : '', awayClass]">{{ currentOdd.now_small_score || '-' }}</div>
    </div>
  </div>
  <div v-else>
    <div class="num-item">
      <div class="num grey">-</div>
      <div class="num grey">-</div>
    </div>
    <div class="num-item">
      <div class="num grey">-</div>
      <div class="num grey">-</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OddItem',
  props: {
    odds: {
      type: Array
    },
    nav: {
      type: Object
    }
  },
  data () {
    return {
      homeClass: '',
      awayClass: ''
    }
  },
  computed: {
    navOddIdx () {
      return this.odds.findIndex(i => (this.nav.id !== 1001 && this.nav.id === i.type) || (this.nav.id === 1001 && this.nav.id === i.type && this.nav.name === i.game_count))
    },
    currentOdd () {
      if (this.navOddIdx > -1) {
        return this.odds[this.navOddIdx]
      } else {
        return null
      }
    }
  },
  watch: {
    'currentOdd.now_score': function (val, oldVal) {
      if (val - oldVal > 0) {
        this.homeClass = 'up'
      } else if (val - oldVal < 0) {
        this.homeClass = 'down'
      }
      if (this.homeTimeOut) {
        clearTimeout(this.homeTimeOut)
      }
      this.homeTimeOut = setTimeout(() => this.homeClass = '', 2000)
    },
    'currentOdd.now_small_score': function (val, oldVal) {
      if (val - oldVal > 0) {
        this.awayClass = 'up'
      } else if (val - oldVal < 0) {
        this.awayClass = 'down'
      }
      if (this.awayTimeOut) {
        clearTimeout(this.awayTimeOut)
      }
      this.awayTimeOut = setTimeout(() => this.awayClass = '', 2000)
    }
  },
}
</script>

<style lang="less" scoped>
.num-item {
  flex: 1;
  align-items: center;
  display: flex;
  width: 100%;
  &:first-child {
    box-shadow: inset 0px -1px 0px 0px rgba(0,0,0,0.25), inset 0px 0px 0px 0px rgba(0,0,0,0.25);
  }
  .up {
    color: #E65668;
  }
  .down {
    color: #98CB4A;
  }
  .num {
    flex: 1;
    text-align: center;
    justify-content: center;
    &.grey {
      color: #705B5D;
    }
  }
}
</style>